module.exports = __webpack_public_path__ + "static/media/la-corporate-catering-1.199d6ef5.jpg";